import React from 'react'

const InputField = ({field, validate}) => {
  let hasErrors = field.errors.length > 0 ? true : false
  return (
    <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
      <label className="col-form-label col-form-label-sm">{field.rules.title}</label>
      <div className="input-group">
        {field.icon && (
          <span className="input-group-addon rounded-left">
            <i
              className={
                hasErrors ? 'material-icons text-danger' : 'material-icons'
              }>
              {field.icon}
            </i>
          </span>
        )}
        <input
          placeholder={field.placeholder || ''}
          type={field.type}
          className={
            hasErrors
              ? 'form-control form-control-sm is-invalid'
              : 'form-control form-control-sm'
          }
          name={field.name}
          onBlur={e => validate(e.target.value, field)}
          value={field.value}
          onChange={e => validate(e.target.value, field)}
          disabled={field.disabled}
        />
      </div>
      {field.errors.map((error, i) => (
        <div key={i} className="form-text text-danger">
          {error}
        </div>
      ))}
    </div>
  )
}

export default (InputField)
